export default __webpack_public_path__ + "static/media/launch.33ab7879.svg";